module.exports = __webpack_public_path__ + "static/media/abbiamo9.04519449.png";